import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { useAppSelector } from "src/store";
import { createHowToUseSaga } from "src/store/web-howtouse/saga";
import * as Yup from "yup";

const HowToUseCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("HowToUse.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Title: "",
          Description: "",
          Icon: "",
          ShowWeb: false,
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Title: "", Description: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createHowToUseSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Title: Yup.string().required(t("Validation.Required").toString()),
          Icon: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Description: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Title",
            label: t("HowToUse.Title").toString(),
            type: "textarea",
          },
          {
            field: "Description",
            label: t("HowToUse.Description").toString(),
            isEditor: true,
          },
        ]}
        inputs={[
          {
            field: "Icon",
            placement: "top",
            label: t("HowToUse.Icon").toString(),
            type: "select",
            lookup: {
              renderValue: (e) => <i className={e} />,
              labelKey: "Id",
              valueKey: "Id",
              options: dripiconlist.map((x, i) => {
                return {
                  Id: x,
                  Name: x,
                };
              }),
            },
          },
          {
            field: "ShowWeb",
            label: t("HowToUse.ShowWeb").toString(),
            type: "switch",
            col: 6,
          },
        ]}
      />
    </React.Fragment>
  );
};
export default HowToUseCreateForm;
